// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M6jI0","toggle":"styles_toggle__3j2SO","preview":"styles_preview__1w3bQ"};